export default "__VITE_ASSET__7bc43964__"